(() => {
  const BASELINE_WEIGHT = 176;
  const FORK_INCREMENT = 0.1 / 11;
  const SHOCK_INCREMENT = 1 / 11;
  const AUSTRIAN_SHOCK_INCREMENT = 1.5 / 11;
  const AER_INCREMENT = 0.1 / 11;
  const FORK_STEP = 0.2;
  const N_PER_KG_MM = 9.80665;
  const AUSTRIAN_BRANDS = new Set(["GasGas", "Husqvarna", "KTM"]);

  const bikeData = {
    Ducati: {
      "Desmo 450": [{ start: 2025, end: 2026, fork: 5.3, shock: 46 }]
    },
    GasGas: {
      "MC 125": [
        { start: 2021, end: 2022, fork_spring: 4.2, fork_aer: 8.56, shock: 42, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.4, fork_aer: 8.76, shock: 43.5, fork_types: ["Spring", "AER"] }
      ],
      "MC 150": [
        { start: 2021, end: 2022, fork_spring: 4.2, fork_aer: 8.56, shock: 42, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.4, fork_aer: 8.76, shock: 43.5, fork_types: ["Spring", "AER"] }
      ],
      "MC 250": [
        { start: 2021, end: 2022, fork_spring: 4.4, fork_aer: 10.36, shock: 45, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.6, fork_aer: 10.56, shock: 46.5, fork_types: ["Spring", "AER"] }
      ],
      "MC 300": [
        { start: 2021, end: 2022, fork_spring: 4.4, fork_aer: 10.36, shock: 48, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.6, fork_aer: 10.56, shock: 49.5, fork_types: ["Spring", "AER"] }
      ],
      "MC 250F": [
        { start: 2021, end: 2022, fork_spring: 4.6, fork_aer: 10.56, shock: 45, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.8, fork_aer: 10.76, shock: 46.5, fork_types: ["Spring", "AER"] }
      ],
      "EX 250F": [
        { start: 2021, end: 2022, fork_spring: 4.6, fork_aer: 10.56, shock: 45, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.8, shock: 46.5, fork_types: ["Spring"] }
      ],
      "MC 350F": [
        { start: 2021, end: 2022, fork_spring: 4.6, fork_aer: 10.56, shock: 45, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.8, fork_aer: 10.76, shock: 46.5, fork_types: ["Spring", "AER"] }
      ],
      "EX 350F": [
        { start: 2021, end: 2022, fork_spring: 4.6, fork_aer: 10.56, shock: 45, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.8, shock: 46.5, fork_types: ["Spring"] }
      ],
      "MC 450F": [
        { start: 2021, end: 2022, fork_spring: 4.8, fork_aer: 10.76, shock: 48, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 5, fork_aer: 10.96, shock: 49.5, fork_types: ["Spring", "AER"] }
      ],
      "EX 450F": [
        { start: 2021, end: 2022, fork_spring: 4.8, fork_aer: 10.76, shock: 48, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 5, shock: 49.5, fork_types: ["Spring"] }
      ]
    },
    Honda: {
      CRF250R: [
        { start: 2022, end: 2024, fork: 4.8, shock: 52 },
        { start: 2025, end: 2026, fork: 5.2, shock: 52 }
      ],
      CRF450R: [
        { start: 2021, end: 2024, fork: 5, shock: 54 },
        { start: 2025, end: 2026, fork: 5.4, shock: 54 }
      ]
    },
    Husqvarna: {
      "TC 125": [
        { start: 2016, end: 2022, fork_spring: 4.2, fork_aer: 8.56, shock: 42, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.4, fork_aer: 8.76, shock: 43.5, fork_types: ["Spring", "AER"] }
      ],
      "TC 250": [
        { start: 2016, end: 2022, fork_spring: 4.4, fork_aer: 10.36, shock: 45, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.6, fork_aer: 10.56, shock: 46.5, fork_types: ["Spring", "AER"] }
      ],
      "TX 300": [
        { start: 2016, end: 2022, fork_spring: 4.4, fork_aer: 10.36, shock: 48, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.6, fork_aer: 10.56, shock: 49.5, fork_types: ["Spring", "AER"] }
      ],
      "FC 250": [
        { start: 2016, end: 2022, fork_spring: 4.6, fork_aer: 10.56, shock: 45, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.8, fork_aer: 10.76, shock: 46.5, fork_types: ["Spring", "AER"] }
      ],
      "FX 250": [
        { start: 2016, end: 2022, fork_spring: 4.6, fork_aer: 10.56, shock: 45, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.8, fork_aer: 10.76, shock: 46.5, fork_types: ["Spring", "AER"] }
      ],
      "FC 350": [
        { start: 2016, end: 2022, fork_spring: 4.6, fork_aer: 10.56, shock: 45, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.8, fork_aer: 10.76, shock: 46.5, fork_types: ["Spring", "AER"] }
      ],
      "FX 350": [
        { start: 2016, end: 2022, fork_spring: 4.6, fork_aer: 10.56, shock: 45, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.8, fork_aer: 10.76, shock: 46.5, fork_types: ["Spring", "AER"] }
      ],
      "FC 450": [
        { start: 2016, end: 2022, fork_spring: 4.8, fork_aer: 10.76, shock: 48, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 5, fork_aer: 10.96, shock: 49.5, fork_types: ["Spring", "AER"] }
      ],
      "FX 450": [
        { start: 2016, end: 2022, fork_spring: 4.8, fork_aer: 10.76, shock: 48, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 5, fork_aer: 10.96, shock: 49.5, fork_types: ["Spring", "AER"] }
      ],
      "FE 250": [
        { start: 2016, end: 2022, fork_spring: 4.6, fork_aer: 10.56, shock: 45, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.8, shock: 46.5, fork_types: ["Spring"] }
      ],
      "FE 350": [
        { start: 2016, end: 2022, fork_spring: 4.6, fork_aer: 10.56, shock: 45, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.8, shock: 46.5, fork_types: ["Spring"] }
      ],
      "FE 450": [
        { start: 2016, end: 2022, fork_spring: 4.8, fork_aer: 10.76, shock: 48, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 5, shock: 49.5, fork_types: ["Spring"] }
      ],
      "FE 501": [
        { start: 2016, end: 2022, fork_spring: 4.8, fork_aer: 10.76, shock: 48, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 5, shock: 49.5, fork_types: ["Spring"] }
      ]
    },
    Kawasaki: {
      KX250: [
        { start: 2020, end: 2024, fork: 5, shock: 54 },
        { start: 2025, end: 2026, fork: 5.45, shock: 57 }
      ],
      KX450: [
        { start: 2019, end: 2023, fork: 5.2, shock: 56 },
        { start: 2024, end: 2026, fork: 5.5, shock: 59 }
      ]
    },
    KTM: {
      "125 SX": [
        { start: 2016, end: 2022, fork_spring: 4.2, fork_aer: 8.56, shock: 42, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.4, fork_aer: 8.76, shock: 43.5, fork_types: ["Spring", "AER"] }
      ],
      "150 SX": [
        { start: 2016, end: 2022, fork_spring: 4.2, fork_aer: 8.56, shock: 42, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.4, fork_aer: 8.76, shock: 43.5, fork_types: ["Spring", "AER"] }
      ],
      "250 SX": [
        { start: 2016, end: 2022, fork_spring: 4.4, fork_aer: 10.36, shock: 45, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.6, fork_aer: 10.56, shock: 46.5, fork_types: ["Spring", "AER"] }
      ],
      "300 SX": [
        { start: 2016, end: 2022, fork_spring: 4.4, fork_aer: 10.36, shock: 48, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.6, fork_aer: 10.56, shock: 49.5, fork_types: ["Spring", "AER"] }
      ],
      "250 SX-F": [
        { start: 2016, end: 2022, fork_spring: 4.6, fork_aer: 10.56, shock: 45, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.8, fork_aer: 10.76, shock: 46.5, fork_types: ["Spring", "AER"] }
      ],
      "250 XC-F": [
        { start: 2016, end: 2022, fork_spring: 4.6, fork_aer: 10.56, shock: 45, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.8, fork_aer: 10.76, shock: 46.5, fork_types: ["Spring", "AER"] }
      ],
      "350 SX-F": [
        { start: 2016, end: 2022, fork_spring: 4.6, fork_aer: 10.56, shock: 45, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.8, fork_aer: 10.76, shock: 46.5, fork_types: ["Spring", "AER"] }
      ],
      "350 XC-F": [
        { start: 2016, end: 2022, fork_spring: 4.6, fork_aer: 10.56, shock: 45, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 4.8, fork_aer: 10.76, shock: 46.5, fork_types: ["Spring", "AER"] }
      ],
      "450 SX-F": [
        { start: 2016, end: 2022, fork_spring: 4.8, fork_aer: 10.76, shock: 48, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 5, fork_aer: 10.96, shock: 49.5, fork_types: ["Spring", "AER"] }
      ],
      "450 XC-F": [
        { start: 2016, end: 2022, fork_spring: 4.8, fork_aer: 10.76, shock: 48, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 5, fork_aer: 10.96, shock: 49.5, fork_types: ["Spring", "AER"] }
      ],
      "500 XC-W": [
        { start: 2016, end: 2022, fork_spring: 4.8, fork_aer: 10.76, shock: 48, fork_types: ["Spring", "AER"] },
        { start: 2023, end: 2025, fork_spring: 5, shock: 49.5, fork_types: ["Spring"] }
      ]
    },
    Stark: {
      Varg: [{ start: 2023, end: 2026, fork: 5.6, shock: 64 }]
    },
    Suzuki: {
      RMZ250: [{ start: 2019, end: 2026, fork: 5.1, shock: 56.5 }],
      RMZ450: [{ start: 2019, end: 2026, fork: 5.4, shock: 59 }]
    },
    Triumph: {
      "TF250-X": [{ start: 2024, end: 2026, fork: 4.94, shock: 59.36 }],
      TF450: [{ start: 2025, end: 2026, fork: 5.14, shock: 61.36 }]
    },
    Yamaha: {
      YZ250: [{ start: 2022, end: 2026, fork: 4.6, shock: 56 }],
      YZ250F: [
        { start: 2020, end: 2024, fork: 5.2, shock: 58 },
        { start: 2025, end: 2026, fork: 5.4, shock: 60 }
      ],
      YZ450F: [
        { start: 2023, end: 2024, fork: 5.6, shock: 64 },
        { start: 2025, end: 2025, fork: 5.6, shock: 62 },
        { start: 2026, end: 2026, fork: 5.2, shock: 62 }
      ]
    }
  };

  const fields = ["brand", "model", "year", "useType", "forkType", "height", "weight", "forkDelta", "shockDelta"];

  function parseHeightInches(value) {
    const text = String(value || "").trim().toLowerCase().replace(/"/g, "").replace(/\s+/g, "");
    if (!text) return null;
    if (text.includes("'")) {
      const [feetText, inchesText = "0"] = text.split("'");
      const feet = Number.parseFloat(feetText || "0");
      const inches = Number.parseFloat(inchesText || "0");
      return Number.isFinite(feet) && Number.isFinite(inches) ? feet * 12 + inches : null;
    }
    if (text.endsWith("in")) {
      const inches = Number.parseFloat(text.slice(0, -2));
      return Number.isFinite(inches) ? inches : null;
    }
    const number = Number.parseFloat(text);
    if (!Number.isFinite(number)) return null;
    return number <= 8 ? number * 12 : number;
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(value, max));
  }

  function roundHalfEven(value) {
    const floor = Math.floor(value);
    const diff = value - floor;
    if (diff < 0.5 - Number.EPSILON) return floor;
    if (diff > 0.5 + Number.EPSILON) return floor + 1;
    return floor % 2 === 0 ? floor : floor + 1;
  }

  function roundToStep(value, step) {
    return roundHalfEven(value / step) * step;
  }

  function formatRate(value, digits = 2) {
    if (!Number.isFinite(value)) return "-";
    const rounded = Number(value.toFixed(digits));
    return Number.isInteger(rounded) ? rounded.toFixed(1) : String(rounded);
  }

  function formatProductRate(value) {
    if (!Number.isFinite(value)) return "-";
    const rounded = Number(value.toFixed(1));
    return Number.isInteger(rounded) ? String(rounded) : String(rounded);
  }

  function formatFixed(value, digits) {
    if (!Number.isFinite(value)) return "-";
    return value.toFixed(digits);
  }

  function normalizePartNumber(value) {
    return String(value || "").replace(/[^a-z0-9]/gi, "").toUpperCase();
  }

  function productUrl(partNumber, type) {
    const normalized = normalizePartNumber(partNumber);
    if (!normalized) return "";
    if (normalized.startsWith("82000")) return "";
    const slug = normalized.toLowerCase();
    if (type === "fork") return `/products/fork-spring-${slug}`;
    return `/products/shock-spring-${slug}-1`;
  }

  function getForkRule(brand, model, year) {
    if (AUSTRIAN_BRANDS.has(brand)) return { prefix: "QS23", min: 3.8, max: 5.8 };
    if (brand === "Yamaha") return { prefix: "QS31", min: 3.8, max: 5.6 };
    if (brand === "Kawasaki") return { prefix: "QS33", min: 4, max: 5.6 };
    if (brand === "Honda") return year <= 2024 ? { prefix: "QS33", min: 4, max: 5.6 } : { prefix: "QS40", min: 4.2, max: 5.6 };
    if (brand === "Suzuki") return model.includes("250") ? { prefix: "QS31", min: 3.8, max: 5.6 } : { prefix: "QS33", min: 4, max: 5.6 };
    if (brand === "Ducati") return { prefix: "QS33", min: 4, max: 5.6 };
    if (brand === "Triumph") return { prefix: "QS31", min: 3.8, max: 5.6 };
    if (brand === "Stark") return { prefix: "QS31", min: 3.8, max: 5.6 };
    return null;
  }

  function getShockRule(brand, model) {
    if (AUSTRIAN_BRANDS.has(brand)) return { prefix: "882.00", min: 37, max: 66 };
    if (brand === "Yamaha") {
      if (model === "YZ250F") return { prefix: "820.00", min: 50, max: 63, available: [50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 63] };
      return { prefix: "897.00", min: 45, max: 63 };
    }
    if (brand === "Kawasaki" || brand === "Honda" || brand === "Ducati") return { prefix: "881.00", min: 47, max: 63 };
    if (brand === "Suzuki") return model.includes("250") ? { prefix: "897.00", min: 45, max: 63 } : { prefix: "881.00", min: 47, max: 63 };
    if (brand === "Triumph" || brand === "Stark") return { prefix: "897.00", min: 45, max: 63 };
    return null;
  }

  function buildForkPart(rate, rule) {
    if (!rule) return null;
    const recommended = roundToStep(clamp(rate, rule.min, rule.max), FORK_STEP);
    const suffix = String(Math.round(recommended * 10)).padStart(2, "0");
    return { rate: recommended, part: `${rule.prefix}${suffix}` };
  }

  function buildShockPart(rate, rule) {
    if (!rule) return null;
    const converted = clamp((rate / N_PER_KG_MM) * 10, rule.min, rule.max);
    const available = rule.available || Array.from({ length: Math.floor((rule.max - rule.min) / 2) + 1 }, (_, index) => rule.min + index * 2);
    const sellable = available.reduce((best, current) => {
      const bestDelta = Math.abs(best - converted);
      const currentDelta = Math.abs(current - converted);
      return currentDelta < bestDelta || (currentDelta === bestDelta && current < best) ? current : best;
    }, available[0]);
    return { rate: sellable, part: `${rule.prefix}${String(sellable).padStart(2, "0")}` };
  }

  function findBaseline(brand, model, year) {
    const entries = bikeData[brand]?.[model] || [];
    return entries.find((entry) => entry.start <= year && year <= entry.end) || null;
  }

  function allYears(entries) {
    const years = new Set();
    entries.forEach((entry) => {
      for (let year = entry.start; year <= entry.end; year += 1) years.add(year);
    });
    return [...years].sort((a, b) => b - a);
  }

  function setOptions(select, options, selected) {
    const prior = selected ?? select.value;
    select.innerHTML = "";
    options.forEach((option) => {
      const node = document.createElement("option");
      node.value = String(option);
      node.textContent = String(option);
      select.append(node);
    });
    if (options.map(String).includes(String(prior))) select.value = String(prior);
  }

  function setLink(link, url, enabled) {
    if (enabled && url) {
      link.href = url;
      link.setAttribute("aria-disabled", "false");
      link.removeAttribute("tabindex");
      return;
    }
    link.href = "#";
    link.setAttribute("aria-disabled", "true");
    link.setAttribute("tabindex", "-1");
  }

  function percent(value, min, max) {
    if (!Number.isFinite(value)) return 0;
    return clamp(((value - min) / (max - min)) * 100, 4, 100);
  }

  function initializeCalculator(root) {
    const input = Object.fromEntries(fields.map((name) => [name, root.querySelector(`[data-rep-field="${name}"]`)]));
    const output = Object.fromEntries([...root.querySelectorAll("[data-rep-output]")].map((node) => [node.dataset.repOutput, node]));
    const forkTypeWrapper = root.querySelector("[data-rep-fork-type-wrapper]");
    const form = root.querySelector(".rep-spring-calculator__form");
    const resetButton = root.querySelector("[data-rep-reset]");

    function populateModels() {
      const brand = input.brand.value;
      const models = Object.keys(bikeData[brand] || {});
      setOptions(input.model, models);
      populateYears();
    }

    function populateYears() {
      const brand = input.brand.value;
      const model = input.model.value;
      const entries = bikeData[brand]?.[model] || [];
      setOptions(input.year, allYears(entries));
      populateForkTypes();
    }

    function populateForkTypes() {
      const baseline = findBaseline(input.brand.value, input.model.value, Number.parseInt(input.year.value, 10));
      const types = baseline?.fork_types || ["Spring"];
      setOptions(input.forkType, types);
      forkTypeWrapper.hidden = types.length <= 1;
      calculate();
    }

    function showError(message) {
      root.classList.add("rep-spring-calculator__error");
      output.bikeTitle.textContent = "Recommended setup";
      output.forkValue.textContent = "-";
      output.shockValue.textContent = "-";
      output.forkProduct.textContent = "-";
      output.shockProduct.textContent = "-";
      output.status.textContent = message;
      output.forkBand.textContent = "-";
      output.shockBand.textContent = "-";
      output.forkBar.style.width = "4%";
      output.shockBar.style.width = "4%";
      output.effectiveWeight.textContent = "-";
      setLink(output.forkLink, "", false);
      setLink(output.shockLink, "", false);
    }

    function calculate() {
      const brand = input.brand.value;
      const model = input.model.value;
      const year = Number.parseInt(input.year.value, 10);
      const height = parseHeightInches(input.height.value);
      const weight = Number.parseFloat(input.weight.value);
      const forkDelta = Number.parseFloat(input.forkDelta.value || "0");
      const shockDelta = Number.parseFloat(input.shockDelta.value || "0");
      const useType = input.useType.value;
      const forkType = input.forkType.value || "Spring";
      const baseline = findBaseline(brand, model, year);

      if (!baseline) return showError("No spring data for this bike and year.");
      if (!Number.isFinite(height) || !Number.isFinite(weight) || !Number.isFinite(forkDelta) || !Number.isFinite(shockDelta)) {
        return showError("One or more inputs need a valid number.");
      }

      root.classList.remove("rep-spring-calculator__error");
      const isAustrian = AUSTRIAN_BRANDS.has(brand);
      const heightAdd = height >= 72 ? 5 : 0;
      const effectiveWeight = weight + heightAdd;
      const diff = effectiveWeight - BASELINE_WEIGHT;
      let shock = baseline.shock + diff * (isAustrian ? AUSTRIAN_SHOCK_INCREMENT : SHOCK_INCREMENT) + shockDelta;
      let forkUnit = "N/mm";
      let forkLabel = "Fork spring";
      let fork = baseline.fork_spring ?? baseline.fork ?? 0;

      if (isAustrian && forkType === "AER" && Number.isFinite(baseline.fork_aer)) {
        fork = baseline.fork_aer + diff * AER_INCREMENT + forkDelta;
        forkUnit = "BAR";
        forkLabel = "Fork air pressure";
      } else {
        fork = fork + diff * FORK_INCREMENT + forkDelta;
      }

      if (useType === "SX") {
        if (forkUnit === "N/mm") fork += 0.4;
        shock += 2;
      }

      fork = Number(fork.toFixed(2));
      shock = Number(shock.toFixed(2));

      const forkRule = forkUnit === "N/mm" ? getForkRule(brand, model, year) : null;
      const shockRule = getShockRule(brand, model);
      const forkPart = forkRule ? buildForkPart(fork, forkRule) : null;
      const shockPart = shockRule ? buildShockPart(shock, shockRule) : null;
      let forkStatus = forkPart ? "Fork exact link" : "Missing fork exact link";
      let shockStatus = shockPart ? "Shock exact link" : "Missing shock exact link";

      output.bikeTitle.textContent = `${year} ${brand} ${model}`;
      output.useType.textContent = useType;
      output.forkLabel.textContent = forkLabel;
      output.forkValue.textContent = `${formatRate(fork)} ${forkUnit}`;
      output.shockValue.textContent = `${formatRate(shock)} N/mm`;
      output.effectiveWeight.textContent = `${formatRate(effectiveWeight, 1)} lb`;
      output.forkBand.textContent = forkUnit === "N/mm" ? `${formatRate(fork - 0.07)}-${formatRate(fork + 0.07)} N/mm` : `${formatRate(fork - 0.06)}-${formatRate(fork + 0.06)} BAR`;
      output.shockBand.textContent = `${formatRate(shock - 0.55)}-${formatRate(shock + 0.55)} N/mm`;
      output.forkBar.style.width = `${percent(forkUnit === "N/mm" ? fork : baseline.fork_spring, 3.8, 6)}%`;
      output.shockBar.style.width = `${percent(shock, 37, 66)}%`;

      if (forkPart) {
        output.forkProduct.textContent = `Recommended spring: ${formatProductRate(forkPart.rate)} N/mm | Part number: ${forkPart.part}`;
        setLink(output.forkLink, productUrl(forkPart.part, "fork"), true);
      } else {
        output.forkProduct.textContent = forkUnit === "BAR" ? "Fork spring product not applicable in AER mode." : "No fork spring product rule for this setup.";
        setLink(output.forkLink, "", false);
        if (forkUnit === "BAR") forkStatus = "Fork buy link disabled in AER mode";
      }

      if (shockPart) {
        const kgRate = (shockPart.rate / 10).toFixed(1);
        const nRate = ((shockPart.rate / 10) * N_PER_KG_MM).toFixed(1);
        output.shockProduct.textContent = `Recommended spring: ${kgRate} kg/mm (${nRate} N/mm) | Part number: ${shockPart.part}`;
        const shockUrl = productUrl(shockPart.part, "shock");
        setLink(output.shockLink, shockUrl, Boolean(shockUrl));
        if (!shockUrl) shockStatus = "Missing shock exact link";
      } else {
        output.shockProduct.textContent = "No shock spring product rule for this setup.";
        setLink(output.shockLink, "", false);
      }

      output.status.textContent = `Baseline: ${BASELINE_WEIGHT} lb | Weight: ${formatFixed(weight, 1)} lb | Height Adj: +${heightAdd} lb | Effective: ${formatFixed(effectiveWeight, 1)} lb | Fork Variance: ${forkDelta >= 0 ? "+" : ""}${formatFixed(forkDelta, 2)} | Shock Variance: ${shockDelta >= 0 ? "+" : ""}${formatFixed(shockDelta, 2)} | ${forkStatus} | ${shockStatus} | Use Type: ${useType}`;
    }

    setOptions(input.brand, Object.keys(bikeData));
    populateModels();

    form?.addEventListener("submit", (event) => {
      event.preventDefault();
      calculate();
    });

    resetButton?.addEventListener("click", () => {
      setOptions(input.brand, Object.keys(bikeData), "KTM");
      populateModels();
      input.model.value = "450 SX-F";
      populateYears();
      input.year.value = "2025";
      populateForkTypes();
      input.useType.value = "MX";
      input.height.value = "6'0";
      input.weight.value = "176";
      input.forkDelta.value = "0";
      input.shockDelta.value = "0";
      calculate();
    });

    input.brand.addEventListener("change", populateModels);
    input.model.addEventListener("change", populateYears);
    input.year.addEventListener("change", populateForkTypes);
    ["useType", "forkType", "height", "weight", "forkDelta", "shockDelta"].forEach((name) => {
      input[name].addEventListener("input", calculate);
      input[name].addEventListener("change", calculate);
    });
  }

  document.querySelectorAll("[data-rep-spring-calculator]").forEach(initializeCalculator);
})();
